import { render, staticRenderFns } from "./PrincipalReductionOrderlist.vue?vue&type=template&id=041fffcb&scoped=true"
import script from "./PrincipalReductionOrderlist.vue?vue&type=script&lang=js"
export * from "./PrincipalReductionOrderlist.vue?vue&type=script&lang=js"
import style0 from "./PrincipalReductionOrderlist.vue?vue&type=style&index=0&id=041fffcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fffcb",
  null
  
)

export default component.exports